import React, { useState, useEffect } from "react";
import { Box, Button, Flex, Grid, GridItem, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalOverlay, Stack, Text, useToast } from "@chakra-ui/react";
import {useMutation } from "@apollo/client";
import OtpInput from 'react-otp-input';
import { OTP_MUTATION } from "../Graphql/Mutations";

export default function VerificationModal({ isOpen, onClose, onOpenLoginModal,onOpenResetPasswordModal }) {
  const [OtpQuery, otp] = useMutation(OTP_MUTATION);
  const [verificationCode, setVerificationCode] = useState('');
  const toast = useToast();
  const handleLoginModal = () => {
    onClose();
    onOpenLoginModal();
  }
  const onSubmit = async () => {
    if(otp!==''){
      try {
        console.log("Data in otp modal is: ", verificationCode);
        const otpInput = {
          email: sessionStorage.getItem("email"),
          otp:verificationCode
        };
        console.log(otpInput);
        await OtpQuery({ variables: otpInput });
        //onOpenResetPasswordModal();
      }
      catch (error) {
        console.log("Error in otp modal: ", error);
      }
    }
    else{
      toast({
        title: 'error',
        description: "Please fill the feild",
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: "bottom-left"
      });
    }
  };
  useEffect(() => {
    console.log("error:", otp.error)
    console.log("loading:", otp.loading)
    console.log("data:", otp.data)
    if (otp.data != undefined) {
      if(otp?.data?.verifyPasswordResetOTP?.success){
      toast({
        title: 'Succeed',
        description: 'OTP Verified Successfully',
        status: 'success',
        duration: 4000,
        isClosable: true,
        position: "bottom-left"
      });
      sessionStorage.setItem("otp",verificationCode)
      onClose();
      onOpenResetPasswordModal();
    }
    else{
      toast({
        title: 'Error',
        description: otp?.data?.verifyPasswordResetOTP?.message,
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: "bottom-left"
      });
    }
    }
    if (otp.error != undefined) {
      toast({
        title: 'error',
        description: otp.error.message,
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: "bottom-left"
      });
    }
  }, [otp.data, otp.loading, otp.error])
  return (
    <>
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent pt={6} my={12} backgroundColor={"#ececec"}>
          <ModalCloseButton pt={10} size={"lg"} />
          <ModalBody>
            <Flex
              align={'center'}
              justify={'center'}>
              <Stack
                spacing={4}
                w={'full'}
                maxW={'md'}
                rounded={'xl'}
              >
                <Text lineHeight={1.1} fontSize={"32px"} fontWeight={"500"}>
                  Verification Code
                </Text>
                <OtpInput
                  value={verificationCode}
                  onChange={setVerificationCode}
                  
                  numInputs={6}
                  containerStyle={{marginTop:"20px",marginBottom:"20px",}}
                  inputStyle={{border:"1px solid #000",width:"100%",borderRadius:"5px",padding:"5px"}}
                  renderSeparator={<Box as="span" marginLeft={{base:"4px",sm:"15px"}} marginRight={{base:"4px",sm:"15px"}}> - </Box>}
                  inputType="number"
                  renderInput={(props) => <input {...props} />}
                />
                <Button
                  w={"100%"}
                  mt={"25px"}
                  color={'white'}
                  fontWeight={"500"}
                  _hover={{ bg: "#002B5B" }}
                  bg={"#002B5B"}
                  type="submit"
                  isLoading={otp.loading}
                  onClick={onSubmit}
                >
                  Verify
                </Button>
              </Stack>
            </Flex>
          </ModalBody>
          <ModalFooter w={"100%"} mb={"35px"}>
            <Grid templateColumns='repeat(1, 1fr)' gap={4} justifyContent="start" w={"100%"}>
              <GridItem col={12} >
                <Text fontSize={"14.4px"} fontWeight={"500"} color="#315B84" cursor="pointer" onClick={handleLoginModal}>
                  Back to Login
                </Text>
              </GridItem>
            </Grid>
          </ModalFooter>
        </ModalContent>
      </Modal >
    </>
  )
}
